import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions";
import sampleCombine from 'xstream/extra/sampleCombine';

export function requestCriteriaWithFilters(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_CRITERIA_WITH_FILTERS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/criteria' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestCriteriaWithFilters',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCriteriaWithFilters')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getCriteriaWithFiltersSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCriteriaWithFiltersFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCriteriaWithFilters')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getCriteriaWithFiltersFailed(response));

  return {
    ACTION: httpResponse$
  }
}


export function requestCriteria(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_CRITERIA)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/criteria' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestCriteria',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCriteria')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getCriteriaSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCriteriaFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCriteria')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getCriteriaFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/criteria.js